"use client";

import { useCallback } from "react";

import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { selectItemsCount } from "@jti/store/selectors/selectItemsCount";
import { cartMiniSlice } from "@jti/store/slices/cartMiniSlice";

export const useCartMini = () => {
  const dispatch = useDispatch();
  const cartItemsCount = useSelector(selectItemsCount);

  const openCart = useCallback(() => {
    dispatch(cartMiniSlice.actions.open());
  }, [dispatch]);

  return { cartItemsCount, openCart };
};
